/** Fond des données issues de BlueNote Pocket : champs préremplis et bandeau de la rubrique. */
export const pocketTint = (isDark) => (isDark ? 'rgba(41, 182, 246, 0.16)' : '#e3f2fd');
